import axios from 'axios';

export default function getListing({ page }) {
  const length = 10;
  const start = page * length;
  return new Promise((resolve, reject) => axios
    .get('/account/system-admin/api/v1/collaboration-groups',
      {
        params: {
          start,
          length,
        },
      })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
